import React, { useState, Component } from 'react';
import '../../index.css';
import Title from '../../components/Title';
import {
  getTelecomList,
  getIndustryList,
  checkEmailDuplication,
  checkIdDuplication,
} from '../../modules/NetworkFunction';
import { withRouter } from 'react-router-dom';
import pwHideIcon from '../../icons/ic-pwhide.png';
import pwLookIcon from '../../icons/ic-pwlook.png';

function Privacy({ history }) {
  const userName = window.sessionStorage.getItem('userName');
  const [testData, setTestData] = React.useState({
    userMailPrefix: '',
    userMailDomain: '',
    userPhone1: '',  // 첫 번째 휴대폰 번호 (예: 010)
    userPhone2: '',  // 두 번째 휴대폰 번호 (예: 1234)
    userPhone3: '',  // 세 번째 휴대폰 번호 (예: 5678)
    userPW: '',
    pwConfirm: '',
    company: '',
    industry: '서비스',
    industryDetail: '',
    userName: userName ? userName : '',
    cafe24URL: '',
    serviceTerm: 0,
    marketingTerm: 0,
    youtubeAccount: '',
    youtubeAPIKey: '',
    telecomNo: 1,
    planNo: 1,
  });
  
  // 이메일 도메인 선택 옵션
  const emailDomains = [
    { value: '', label: '직접 입력' },
    { value: 'gmail.com', label: '구글' },
    { value: 'naver.com', label: '네이버' },
    { value: 'daum.net', label: '다음' },
    { value: 'hanmail.net', label: '한메일' },
    { value: 'nate.com', label: '네이트' },
    { value: 'yahoo.co.kr', label: '야후' },
  ];
  
  // 선택한 도메인 값 관리
  const [selectedDomain, setSelectedDomain] = React.useState('');
  
  // 완전한 이메일 주소 계산 (prefix@domain)
  const userMail = testData.userMailPrefix && testData.userMailDomain ? 
    `${testData.userMailPrefix}@${testData.userMailDomain}` : '';

  const emailRegex =
    /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/;
  //const emailRegex_second = /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/;

  const pwRegex = /^[A-Za-z0-9!@#$%^&+=]{8,15}$/;
  const phoneRegex = /^[0-9]{11}$/;
  const [testEmail, setTestEmail] = React.useState(false); // 이메일 정규식

  const companyNameRef = React.useRef();
  const pwRef = React.useRef();
  const pwConfirmRef = React.useRef();
  const pwConfirmDetail = React.useRef();

  const [check, setCheck] = React.useState({
    // 모두 true여야 다음 버튼 활성화
    emailCheck: false, // 이메일 정규식 먼저 통과
    phoneCheck: false, //폰 번호 3개 모두 조건 맞아야함
    pwCheck: false, //8자 이상
    pwConfirmCheck: false, //pw랑 같아야함
    companyNameCheck: false, // 회사명 꼭 입력해야함
  });

  const onChange = (e) => {
    setisemailBtnCheck(false);
    const { value, name } = e.target;

    setTestData({ ...testData, [name]: value });

    if (companyNameRef.current.value.length > 0) {
      setCheck({ ...check, companyNameCheck: true });
    } else {
      setCheck({ ...check, companyNameCheck: false });
    }
    if (
      pwConfirmRef.current.value !== '' &&
      pwRef.current.value == pwConfirmRef.current.value
    ) {
      setCheck({ ...check, pwConfirmCheck: true });
    } else if (pwConfirmRef.current.value == '') {
      setCheck({ ...check, pwConfirmCheck: false });
    }
  };
  
  // 이메일 도메인 선택 시 호출되는 함수
  const handleDomainChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedDomain(selectedValue);
    
    // 직접 입력이 아닌 경우 자동으로 도메인 입력
    if (selectedValue) {
      setTestData({ ...testData, userMailDomain: selectedValue });
    } else {
      // 직접 입력을 선택한 경우 도메인 초기화
      setTestData({ ...testData, userMailDomain: '' });
    }
    
    // 중복확인 초기화
    setisemailBtnCheck(false);
  };

  const [nextBtnDisabled, setNextBtnDisabled] = React.useState(false);

  React.useEffect(() => {
    let v =
      check.emailCheck &&
      check.phoneCheck &&
      check.pwCheck &&
      check.pwConfirmCheck &&
      check.companyNameCheck;
    setNextBtnDisabled(!v);
    // pwConfirmDetail.current.textContent = "비밀번호가 일치하지 않습니다";
  }, [check]);

  const [isemailBtnCheck, setisemailBtnCheck] = React.useState(false);

  const setEmailInfo = () => {
    const fullEmail = testData.userMailPrefix && testData.userMailDomain ? 
      `${testData.userMailPrefix}@${testData.userMailDomain}` : '';
    
    if (fullEmail === '') {
      return { __html: '' };
    } else if (!testEmail) {
      return { __html: '잘못된 형식입니다.' };
    } else if (testEmail && !isemailBtnCheck) {
      return { __html: '' };
    } else if (testEmail && isemailBtnCheck && check.emailCheck) {
      return { __html: '사용할 수 있는 이메일입니다.' };
    } else if (testEmail && isemailBtnCheck && !check.emailCheck) {
      return { __html: '이미 존재하는 이메일입니다.' };
    }
  };

  const checkEmail = () => {
    setisemailBtnCheck(true);
    const fullEmail = `${testData.userMailPrefix}@${testData.userMailDomain}`;
    const emailParam = { userMail: fullEmail };

    let isEmail = false;
    let isId = false;

    // 미중복이면 true
    // 중복이면 false
    checkEmailDuplication(
      emailParam,
      (v) => {
        setCheck({ ...check, emailCheck: v });
        //isEmail = v;
      },
      () => {},
      () => {}
    );

    setEmailInfo();
  };

  const [telecomList, setTelecomList] = React.useState([]);
  const [isTelecomListLoaded, setIsTelecomListLoaded] = React.useState(false);

  const [defaultTelecom, setDefaultTelecom] = React.useState(0);

  const [industryList, setIndustryList] = React.useState([]);
  const [isIndustryListLoaded, setIsIndustryListLoaded] = React.useState(false);
  const [defaultIndustry, setDefaultIndustry] = React.useState('');

  React.useEffect(() => {
    let v = pwRegex.test(testData.userPW);
    setCheck({ ...check, pwCheck: v });
  }, [testData.userPW]);

  React.useEffect(() => {
    const fullEmail = testData.userMailPrefix && testData.userMailDomain ? 
      `${testData.userMailPrefix}@${testData.userMailDomain}` : '';
    let v = emailRegex.test(fullEmail);
    setCheck({ ...check, emailCheck: v });
    setTestEmail(v);
  }, [testData.userMailPrefix, testData.userMailDomain]);

  React.useEffect(() => {
    if (testData.userPW == testData.pwConfirm && testData.pwConfirm != '') {
      setCheck({ ...check, pwConfirmCheck: true });
    } else {
      setCheck({ ...check, pwConfirmCheck: false });
    }
  }, [testData.userPW, testData.pwConfirm]);

  React.useEffect(() => {
    // 세 개의 휴대폰 번호 부분을 합쳐서 검증
    const fullPhoneNumber = `${testData.userPhone1}${testData.userPhone2}${testData.userPhone3}`;
    let v = phoneRegex.test(fullPhoneNumber);
    setCheck({ ...check, phoneCheck: v });
  }, [testData.userPhone1, testData.userPhone2, testData.userPhone3]);

  React.useEffect(() => {
    if (!isTelecomListLoaded) {
      getTelecomList(null, setTelecomList, setIsTelecomListLoaded, (v) => {
        console.log('getTelecomList Error');
      });
      // .then(()=>{
      //   setDefaultTelecom(telecomList[0])
      // })
    }
  }, [isTelecomListLoaded]);

  React.useEffect(() => {
    if (!isIndustryListLoaded) {
      getIndustryList(
        null,
        (e) => {
          //setIndustryList(e);
          setIndustryList([
            ...e,
            { industryName: '패션', industryNo: 4 },
            { industryName: '뷰티', industryNo: 5 },
            { industryName: '푸드', industryNo: 6 },
            { industryName: '가구/인테리어', industryNo: 7 },
            { industryName: '엔터테인먼트', industryNo: 8 },
            { industryName: '여행/숙박', industryNo: 9 },
          ]);
          setDefaultIndustry(industryList[0]);
        },
        (e) => {
          setIsIndustryListLoaded(e);
        },
        (v) => {
          console.log('getIndustryList Error');
        }
      );
      // .then(()=>{
      //   setTestData({...testData, industry:industryList[0]})
      // })
    }
  }, [isIndustryListLoaded]);

  const [passwordType, setPasswordType] = React.useState({
    type: 'password',
    visible: false,
  });

  const [passwordType_bottom, setPasswordType_bottom] = React.useState({
    type: 'password',
    visible: false,
  });

  //password type 변경하는 함수
  const handlePasswordType = (e) => {
    setPasswordType(() => {
      if (!passwordType.visible) {
        return { type: 'text', visible: true };
      }
      return { type: 'password', visible: false };
    });
  };

  return (
    <>
      <Title title="개인정보" />
      <form>
        <div>
          <p
            style={{
              fontSize: 18,
              color:
                !testData.userMailPrefix && !testData.userMailDomain
                  ? '#000'
                  : check.emailCheck
                  ? '#000'
                  : '#FF8A00',
            }}
          >
            이메일*
          </p>
          <div className="input-box">
            <input
              type="text"
              style={{
                width: 120,
                height: 38,
                marginRight: 0,
                borderRadius: '5px',
                border: 0,
                outline:
                  !testData.userMailPrefix && !testData.userMailDomain
                    ? '1px solid #C4C4C4'
                    : check.emailCheck
                    ? '1px solid #C4C4C4'
                    : '1px solid #FF8A00',
              }}
              name="userMailPrefix"
              value={testData.userMailPrefix}
              onChange={(e) => {
                onChange(e);
              }}
              autoComplete="email"
            />
            <span style={{ margin: '0 5px', fontSize: 18 }}>@</span>
            <input
              type="text"
              style={{
                width: 120,
                height: 38,
                marginRight: 5,
                borderRadius: '5px',
                border: 0,
                outline:
                  !testData.userMailPrefix && !testData.userMailDomain
                    ? '1px solid #C4C4C4'
                    : check.emailCheck
                    ? '1px solid #C4C4C4'
                    : '1px solid #FF8A00',
              }}
              name="userMailDomain"
              value={testData.userMailDomain}
              onChange={(e) => {
                onChange(e);
                setSelectedDomain('');
              }}
              autoComplete="email"
              disabled={selectedDomain !== ''}
            />
            <select
              style={{
                width: 100,
                height: 38,
                marginRight: 7,
                borderRadius: '5px',
                cursor: 'pointer',
              }}
              value={selectedDomain}
              onChange={handleDomainChange}
            >
              {emailDomains.map((domain) => (
                <option key={domain.value} value={domain.value}>
                  {domain.label}
                </option>
              ))}
            </select>

            <button
              type="button"
              className={testEmail ? 'normal-button-y' : 'normal-button-g'}
              onClick={checkEmail}
              disabled={!testEmail}
              style={{
                width: 92,
                height: 38,
                marginRight: 7,
                fontSize: 16,
                background:
                  isemailBtnCheck && check.emailCheck ? '#0EB533' : '',
              }}
            >
              {isemailBtnCheck && check.emailCheck ? '사용 가능' : '중복 확인'}
            </button>
            <p
              style={{
                color:
                  isemailBtnCheck && check.emailCheck ? '#0C9429' : '#FF8A00',
              }}
              dangerouslySetInnerHTML={setEmailInfo()}
            ></p>
          </div>
        </div>
        <div>
          <p
            style={{
              fontSize: 18,
              color:
                testData.userPhone === ''
                  ? '#000'
                  : check.phoneCheck
                  ? '#000'
                  : '#FF8A00',
            }}
          >
            휴대폰 번호*
          </p>
          <div className="input-box">
            <select
              onChange={onChange}
              value={testData.telecomNo}
              name="telecomNo"
              // defaultValue={defaultTelecom}
              style={{ width: 89, height: 38, marginRight: 13 }}
            >
              {telecomList.map(function (n) {
                return (
                  <option key={n.telecomName} value={n.telecomNo}>
                    {n.telecomName}
                  </option>
                );
              })}
            </select>
            <input
              type="text"
              name="userPhone1"
              maxLength="3"
              style={{
                width: 80,
                height: 38,
                marginRight: 10,
                borderRadius: '5px',
                border: 0,
                outline:
                  !testData.userPhone1 && !testData.userPhone2 && !testData.userPhone3
                    ? '1px solid #C4C4C4'
                    : check.phoneCheck
                    ? '1px solid #0EB533'
                    : '1px solid #FF8A00',
                textAlign: 'center',
                paddingLeft: 0
              }}
              value={testData.userPhone1}
              onChange={(e) => {
                // 숫자만 입력 가능하도록
                if (e.target.value === '' || /^\d+$/.test(e.target.value)) {
                  onChange(e);
                  // 3자리 다 입력하면 다음 입력란으로 포커스 이동
                  if (e.target.value.length === 3) {
                    document.getElementsByName('userPhone2')[0].focus();
                  }
                }
              }}
              autoComplete="tel"
            />
            <input
              type="text"
              name="userPhone2"
              maxLength="4"
              style={{
                width: 90,
                height: 38,
                marginRight: 10,
                borderRadius: '5px',
                border: 0,
                outline:
                  !testData.userPhone1 && !testData.userPhone2 && !testData.userPhone3
                    ? '1px solid #C4C4C4'
                    : check.phoneCheck
                    ? '1px solid #0EB533'
                    : '1px solid #FF8A00',
                textAlign: 'center',
                paddingLeft: 0
              }}
              value={testData.userPhone2}
              onChange={(e) => {
                // 숫자만 입력 가능하도록
                if (e.target.value === '' || /^\d+$/.test(e.target.value)) {
                  onChange(e);
                  // 4자리 다 입력하면 다음 입력란으로 포커스 이동
                  if (e.target.value.length === 4) {
                    document.getElementsByName('userPhone3')[0].focus();
                  }
                }
              }}
              autoComplete="tel"
            />
            <input
              type="text"
              name="userPhone3"
              maxLength="4"
              style={{
                width: 90,
                height: 38,
                marginRight: 10,
                borderRadius: '5px',
                border: 0,
                outline:
                  !testData.userPhone1 && !testData.userPhone2 && !testData.userPhone3
                    ? '1px solid #C4C4C4'
                    : check.phoneCheck
                    ? '1px solid #0EB533'
                    : '1px solid #FF8A00',
                textAlign: 'center',
                paddingLeft: 0
              }}
              value={testData.userPhone3}
              onChange={(e) => {
                // 숫자만 입력 가능하도록
                if (e.target.value === '' || /^\d+$/.test(e.target.value)) {
                  onChange(e);
                }
              }}
              autoComplete="tel"
            />
            <p
              style={{
                color: check.phoneCheck ? '#0C9429' : '#FF8A00',
              }}
            >
              {!testData.userPhone1 && !testData.userPhone2 && !testData.userPhone3
                ? ''
                : check.phoneCheck
                ? '휴대폰 번호가 확인되었습니다.'
                : '휴대폰 번호는 11자리를 입력해야합니다.'}
            </p>
          </div>
        </div>

        <div>
          <p
            style={{
              fontSize: 18,
              color:
                testData.userPW === ''
                  ? '#000'
                  : check.pwCheck
                  ? '#000'
                  : '#FF8A00',
            }}
          >
            비밀번호*
          </p>
          <div className="input-box">
            <input
              type={passwordType.type}
              name="userPW"
              ref={pwRef}
              value={testData.userPW || ''}
              onChange={(e) => {
                onChange(e);
                let v = pwRegex.test(e.target.value);
                setCheck({ ...check, pwCheck: v });
              }}
              style={{
                width: 295,
                height: 38,
                marginRight: 7,
                borderRadius: '5px',
                border: 0,
                outline:
                  testData.userPW === ''
                    ? '1px solid #C4C4C4'
                    : check.pwCheck
                    ? '1px solid #0EB533'
                    : '1px solid #FF8A00',
                paddingLeft: 10,
              }}
              autoComplete="new-password"
            />
            <span
              style={{ cursor: 'pointer', marginRight: '8px' }}
              onClick={handlePasswordType}
            >
              {passwordType.visible ? (
                <span>
                  <img
                    style={{
                      width: '30px',
                      cursor: 'pointer',
                    }}
                    src={pwHideIcon}
                    alt={'비밀번호 숨기기 아이콘'}
                  />
                </span>
              ) : (
                <span>
                  <img
                    style={{
                      width: '30px',
                      cursor: 'pointer',
                    }}
                    src={pwLookIcon}
                    alt={'비밀번호 보기 아이콘'}
                  />
                </span>
              )}
            </span>
            <p style={{ color: '#FF8A00' }}>
              {testData.userPW === ''
                ? ''
                : check.pwCheck
                ? ''
                : '비밀번호를 8-15자로 설정해주세요.'}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{
              fontSize: 18,
              color:
                testData.pwConfirm === ''
                  ? '#000'
                  : check.pwConfirmCheck
                  ? '#000'
                  : '#FF8A00',
            }}
          >
            비밀번호 확인*
          </p>
          <div className="input-box">
            <input
              type={passwordType_bottom.type}
              name="pwConfirm"
              value={testData.pwConfirm || ''}
              ref={pwConfirmRef}
              onChange={(e) => {
                onChange(e);
              }}
              style={{
                width: 295,
                height: 38,
                marginRight: 7,
                borderRadius: '5px',
                border: 0,
                outline:
                  testData.pwConfirm === ''
                    ? '1px solid #C4C4C4'
                    : check.pwConfirmCheck
                    ? '1px solid #0EB533'
                    : '1px solid #FF8A00',
                paddingLeft: 10,
              }}
              autoComplete="new-password"
            />
            <span style={{ cursor: 'pointer', marginRight: '8px' }}></span>
            <p
              ref={pwConfirmDetail}
              style={{ color: check.pwConfirmCheck ? '#0C9429' : '#FF8A00' }}
            >
              {testData.pwConfirm === ''
                ? ''
                : check.pwConfirmCheck
                ? '비밀번호가 확인되었습니다.'
                : '비밀번호가 일치하지 않습니다.'}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{
              fontSize: 18,
              color:
                testData.company === ''
                  ? '#000'
                  : check.companyNameCheck
                  ? '#000'
                  : '#FF8A00',
            }}
          >
            회사명*
          </p>
          <div className="input-box">
            <input
              type="text"
              name="company"
              value={testData.company}
              onChange={(e) => {
                onChange(e);
                if (e.target.value == '') {
                  setCheck({ ...check, companyNameCheck: false });
                } else {
                  setCheck({ ...check, companyNameCheck: true });
                }
              }}
              style={{
                width: 295,
                height: 38,
                borderRadius: '5px',
                border: 0,
                outline:
                  testData.company === ''
                    ? '1px solid #C4C4C4'
                    : check.companyNameCheck
                    ? '1px solid #C4C4C4'
                    : '1px solid #FF8A00',
              }}
              ref={companyNameRef}
            />
            <p
              style={{
                color: check.companyNameCheck ? '#0C9429' : '#FF8A00',
                marginLeft: '10px',
              }}
            >
              {testData.company === ''
                ? ''
                : check.companyNameCheck
                ? ''
                : '회사명은 반드시 입력해야 합니다.'}
            </p>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div>
            <p style={{ fontSize: 18 }}>업종*</p>
            <div className="input-box">
              <select
                onChange={onChange}
                value={testData.industry}
                name="industry"
                style={{
                  width: 152,
                  height: 38,
                  marginRight: 13,
                  cursor: 'pointer',
                }}
              >
                {industryList.map(function (n) {
                  return (
                    <option key={n.industryName} value={n.industryName}>
                      {n.industryName}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div>
            <p style={{ fontSize: 18 }}>상세 업종</p>
            <div className="input-box">
              <input
                type="text"
                name="industryDetail"
                value={testData.industryDetail}
                style={{ width: 295, height: 38 }}
                onChange={onChange}
                placeholder={'ex) 의류, 잡화편집샵, 스포츠용품 등'}
              />
            </div>
          </div>
        </div>
      </form>
      <div className="footer-div">
        <button
          type="button"
          className={nextBtnDisabled ? 'rounded-button-g' : 'rounded-button-y'}
          disabled={nextBtnDisabled}
          onClick={() => {
            // Combine email parts into a single email for the next page
            // 휴대폰 번호도 합쳐서 전달
            const fullData = {
              ...testData,
              userMail: `${testData.userMailPrefix}@${testData.userMailDomain}`,
              userPhone: `${testData.userPhone1}${testData.userPhone2}${testData.userPhone3}`
            };
            
            // 개별 부분 데이터는 삭제
            delete fullData.userMailPrefix;
            delete fullData.userMailDomain;
            delete fullData.userPhone1;
            delete fullData.userPhone2;
            delete fullData.userPhone3;
            
            history.push({
              pathname: '/signup/terms',
              state: fullData,
            });
          }}
        >
          다음
        </button>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            position: 'absolute',
            bottom: 30,
            right: 40,
          }}
        >
          <p
            style={{
              fontFamily: 'Noto Sans',
              fontSize: 14,
              color: '#B5B5B5',
            }}
          >
            이미 위즈몬의 회원이신가요?
          </p>
          <p
            style={{
              fontFamily: 'Noto Sans',
              fontSize: 14,
              color: '#FFB600',
              cursor: 'pointer',
            }}
            onClick={() => {
              history.push('/');
            }}
          >
            로그인 하러가기
          </p>
        </div>
      </div>
    </>
  );
}

export default withRouter(Privacy);
